import { Config } from "../Interfaces/bucket/Config";
import { Game } from "../Interfaces/bucket/Game";
import { GameResult } from "../Interfaces/bucket/GameResult";
import { Lobby } from "../Interfaces/bucket/Lobby";
import { Score } from "../Interfaces/bucket/Score";
import { User } from "../Interfaces/bucket/User";
import { LoginRequest } from "../Interfaces/function/login/login";
import { SpicaClient } from "./spica.facade";

export class DataService {
  spicaClient = new SpicaClient(
    process.env.REACT_APP_API_URL as string,
    process.env.REACT_APP_PUBLIC_APIKEY as string,
  );

  resources = {
    user: this.spicaClient.createResource<User>(process.env.REACT_APP_USER_BUCKET as string),
    Lobby: this.spicaClient.createResource<Lobby>(process.env.REACT_APP_LOBI_BUCKET as string),
    Game: this.spicaClient.createResource<Game>(process.env.REACT_APP_GAME_BUCKET as string),
    Score: this.spicaClient.createResource<Score>(process.env.REACT_APP_SCORE_BUCKET as string),
    Config: this.spicaClient.createResource<Config>(process.env.REACT_APP_CONFIG_BUCKET as string),
    GameResult: this.spicaClient.createResource<GameResult>(process.env.REACT_APP_GAME_RESULT_BUCKET as string),
    
  };

  cloud_function = {

    joinLobby: this.spicaClient
      .registerCloudFunction('lobby/join')
      .post(),
    leaveFromLobby: this.spicaClient
      .registerCloudFunction('lobby/leave')
      .post(),
    login: this.spicaClient
      .registerCloudFunction<LoginRequest, any>('login')
      .post(),
    register: this.spicaClient
      .registerCloudFunction<LoginRequest, any>('register')
      .post(),
    recoveryPassword: this.spicaClient
      .registerCloudFunction('recoveryPassword')
      .post(),
    verifyCode: this.spicaClient.registerCloudFunction('verifyCode').post(),
    setNewPassword: this.spicaClient
      .registerCloudFunction('setNewPassword')
      .post(),
    myRewards:this.spicaClient.registerCloudFunction('reward/myRewards').get(),
    createList:this.spicaClient.registerCloudFunction('list/new').get(),
    online:this.spicaClient.registerCloudFunction('online').get(),
    withdraw: this.spicaClient.registerCloudFunction('witdhdraw').post()
  };
}
export default new DataService() 